module.exports = __webpack_public_path__ + "img/Fb.155420e6.svg";